import { Link } from "react-router-dom";

export default function WhatIsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="lg:w-1/2 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20office%20with%20large%20monitor%20displaying%20colorful%20product%20inventory%20spreadsheet%20dashboard%2C%20warm%20cream%20walls%2C%20terracotta%20desk%20accessories%2C%20small%20potted%20plant%2C%20natural%20sunlight%20streaming%20through%20window%2C%20clean%20organized%20workspace%2C%20products%20visible%20on%20shelves%2C%20professional%20editorial%20photography%2C%20airy%20atmosphere&width=600&height=450&seq=whatis-vigorbuy-v2&orientation=landscape"
              alt="Vigorbuy Spreadsheet workspace"
              className="w-full h-auto rounded-lg object-cover"
              style={{ height: "300px" }}
            />
          </div>
          <div className="lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
              What Is Vigorbuy Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              Vigorbuy Spreadsheet is a powerful spreadsheet solution designed to help users organize information, manage data, track products and improve workflow efficiency.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Whether you are a beginner or experienced user, understanding spreadsheet structure, templates and best practices can significantly improve productivity. With comprehensive features for business management, inventory tracking and data analysis, Vigorbuy Spreadsheet stands out as a reliable tool for modern data management needs.
            </p>
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-label font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Learn More About Vigorbuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}